export const AvatarStyles = ({theme: {fonts, icons}}) => {
  return {
    text: {
      ...fonts.CAPTION_LARGE,
      color: '#FFFFFF',
    },
  };
};
